const pintuanRoutes = [
    // {
    //     path: '/pintuan',
    //     name: 'Pintuan',
    //     component: () => import('../views/Pintuan/list.vue')
    // }
]

export default pintuanRoutes;